export const ViewDetailStyles = (theme) => (
  {
    color: theme.palette.blue.main,
    fontSize: 16,
    fontFamily: 'Inter',
    fontWeight: 700,
    letterSpacing: '0.32px'
  }
);
export default (theme) => ({
  success: {
    color: theme.status.success,
    fontWeight: '700'
  },
  danger: {
    color: theme.status.danger,
    fontWeight: '700'
  },
  warning: {
    color: theme.status.warning,
    fontWeight: '700'
  },
});
